import { logoutRequest } from '../../api/authorization/logout';
import Routes from '../../constants/routes';
import clearStorage from '../../utils/browser-storage/clear-storage';

export default function logout(redirectToLogin = false) {
    logoutRequest().then(async () => {
        clearStorage();

        if (redirectToLogin) {
            window.locationReload(Routes.LOGIN.path);
        } else {
            window.location.reload();
        }
    });
}
